import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IDepartment, IEdge } from '@api/types'
import { DepartmentSearchFragment } from '@api/fragments'

interface Payload {
  data: {
    viewer: {
      company: {
        search: {
          departments: {
            edges: IEdge<IDepartment>[]
          }
        }
      }
    }
  }
}

export default function searchDepartment(query: string): Promise<IDepartment[]> {
  const variables = { query }

  return client.gql.query({ query: q, variables }).then(
    ({
      data: {
        viewer: {
          company: {
            search: {
              departments: { edges },
            },
          },
        },
      },
    }: Payload) => edges.map(({ node }) => node)
  )
}

const q = gql`
  query DepartmentSearch($query: String!) {
    viewer {
      company {
        search(query: $query, type: departments) {
          departments(first: 9) {
            edges {
              node {
                ...DepartmentSearchFragment
                parentDepartment {
                  ...DepartmentSearchFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${DepartmentSearchFragment}
`
